var M = Object.defineProperty;
var P = (t, e, i) => e in t ? M(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var n = (t, e, i) => (P(t, typeof e != "symbol" ? e + "" : e, i), i);
const R = "datalake_session", de = 18e5, E = (t) => Number(t) ? new Date(Number(t)).getTime() > 0 : !1, j = (t = 18e5) => {
  const e = localStorage.getItem(R), i = typeof t == "number" && !isNaN(t) ? t : 18e5;
  if (!e)
    return null;
  try {
    const r = JSON.parse(e);
    return !["id", "lastActivity", "startTime"].every((d) => Object.hasOwn(r, d)) || !E(r.startTime) || !E(r.lastActivity) || r.lastActivity <= Date.now() - i ? null : r;
  } catch {
    return null;
  }
}, ue = (t = 18e5) => {
  const e = j(t);
  return e == null ? void 0 : e.id;
}, C = (t) => ({
  id: crypto.randomUUID(),
  time_triggered: (/* @__PURE__ */ new Date()).getTime(),
  context_client_viewport_width: window.innerWidth,
  context_client_viewport_height: window.innerHeight,
  context_language: navigator.language,
  context_timezone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
  context_timezone_utc_offset: (/* @__PURE__ */ new Date()).getTimezoneOffset(),
  ...t
}), F = (t) => typeof t != "object" ? t : Object.keys(t).reduce((e, i) => ({
  ...e,
  [i]: JSON.stringify(t[i])
}), {});
class V {
  constructor(e) {
    n(this, "originalPushState", window.history.pushState);
    n(this, "originalReplaceState", window.history.replaceState);
    n(this, "currentUrl", null);
    n(this, "trigger", () => {
      this.currentUrl !== window.location.pathname && (this.currentUrl = window.location.pathname, this.onNavigate(window.location.pathname));
    });
    this.onNavigate = e, this.subscribe();
  }
  destroy() {
    this.unsubscribe();
  }
  subscribe() {
    window.addEventListener("popstate", this.trigger), this.originalPushState = window.history.pushState, window.history.pushState = (...e) => {
      this.originalPushState.apply(window.history, e), this.trigger();
    }, this.originalReplaceState = window.history.replaceState, window.history.replaceState = (...e) => {
      this.originalReplaceState.apply(window.history, e), this.trigger();
    };
  }
  unsubscribe() {
    window.removeEventListener("popstate", this.trigger), window.history.pushState = this.originalPushState, window.history.replaceState = this.originalReplaceState;
  }
}
var m = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var q = "Expected a function", N = NaN, B = "[object Symbol]", J = /^\s+|\s+$/g, W = /^[-+]0x[0-9a-f]+$/i, G = /^0b[01]+$/i, z = /^0o[0-7]+$/i, H = parseInt, Q = typeof m == "object" && m && m.Object === Object && m, K = typeof self == "object" && self && self.Object === Object && self, X = Q || K || Function("return this")(), Y = Object.prototype, Z = Y.toString, ee = Math.max, te = Math.min, w = function() {
  return X.Date.now();
};
function ie(t, e, i) {
  var r, o, c, d, a, u, h = 0, b = !1, f = !1, v = !0;
  if (typeof t != "function")
    throw new TypeError(q);
  e = k(e) || 0, _(i) && (b = !!i.leading, f = "maxWait" in i, c = f ? ee(k(i.maxWait) || 0, e) : c, v = "trailing" in i ? !!i.trailing : v);
  function y(s) {
    var l = r, g = o;
    return r = o = void 0, h = s, d = t.apply(g, l), d;
  }
  function x(s) {
    return h = s, a = setTimeout(p, e), b ? y(s) : d;
  }
  function L(s) {
    var l = s - u, g = s - h, I = e - l;
    return f ? te(I, c - g) : I;
  }
  function T(s) {
    var l = s - u, g = s - h;
    return u === void 0 || l >= e || l < 0 || f && g >= c;
  }
  function p() {
    var s = w();
    if (T(s))
      return O(s);
    a = setTimeout(p, L(s));
  }
  function O(s) {
    return a = void 0, v && r ? y(s) : (r = o = void 0, d);
  }
  function A() {
    a !== void 0 && clearTimeout(a), h = 0, r = u = o = a = void 0;
  }
  function U() {
    return a === void 0 ? d : O(w());
  }
  function S() {
    var s = w(), l = T(s);
    if (r = arguments, o = this, u = s, l) {
      if (a === void 0)
        return x(u);
      if (f)
        return a = setTimeout(p, e), y(u);
    }
    return a === void 0 && (a = setTimeout(p, e)), d;
  }
  return S.cancel = A, S.flush = U, S;
}
function _(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function ne(t) {
  return !!t && typeof t == "object";
}
function re(t) {
  return typeof t == "symbol" || ne(t) && Z.call(t) == B;
}
function k(t) {
  if (typeof t == "number")
    return t;
  if (re(t))
    return N;
  if (_(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = _(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(J, "");
  var i = G.test(t);
  return i || z.test(t) ? H(t.slice(2), i ? 2 : 8) : W.test(t) ? N : +t;
}
var se = ie;
const oe = /* @__PURE__ */ $(se), D = ["scroll", "keydown", "click"];
class ae {
  constructor(e, i = 18e5) {
    n(this, "updateLastActivity", oe(() => {
      this.session();
    }, 100));
    n(this, "trackEvents", () => {
      D.forEach((e) => window.addEventListener(e, this.updateLastActivity));
    });
    n(this, "store", (e) => {
      localStorage.setItem(R, JSON.stringify(e));
    });
    n(this, "destroy", () => {
      D.forEach((e) => window.removeEventListener(e, this.updateLastActivity));
    });
    this.onSessionStart = e, this.duration = i, this.session(), this.trackEvents();
  }
  // This method is used to create a new session or update the last activity of the current session
  session() {
    const e = j(this.duration), i = {
      id: (e == null ? void 0 : e.id) ?? crypto.randomUUID(),
      lastActivity: Date.now(),
      startTime: (e == null ? void 0 : e.startTime) ?? Date.now()
    };
    return this.store(i), e || this.onSessionStart(), i;
  }
  updateDuration(e) {
    this.duration = e;
  }
}
class le {
  constructor(e) {
    n(this, "queue", []);
    n(this, "navigationManager");
    n(this, "options");
    n(this, "overrides", {});
    n(this, "currentPageRecordId", null);
    n(this, "sessionManager");
    n(this, "destroy", () => {
      this.navigationManager.destroy(), this.sessionManager.destroy(), document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    });
    n(this, "handleVisibilityChange", () => {
      document.visibilityState === "hidden" && this.flush();
    });
    n(this, "logPageView", () => {
      this.navigationManager.trigger();
    });
    n(this, "handleNavigation", (e) => {
      const i = this.logEvent("pageView", { url: e }, { parentRecordId: null });
      this.currentPageRecordId = i.id ?? null;
    });
    n(this, "handleSessionStart", () => {
      this.logEvent("session_start", {}, { parentRecordId: null });
    });
    n(this, "logEvent", (e, i, r) => {
      const o = window.parent ?? this.currentPageRecordId;
      return this.options.verbose && console.log("DataLakeClient: logEvent", e, i, o), this.addToQueue(e, i, r);
    });
    n(this, "setOverrides", (e) => {
      typeof e == "function" ? this.overrides = e(this.overrides) : this.overrides = {
        ...this.overrides,
        ...e
      };
    });
    n(this, "resetUser", () => {
      const {
        context_user_distinct_id: e,
        context_user_username: i,
        context_user_email: r,
        context_user_id: o,
        context_user_data: c,
        context_user_first_name: d,
        context_user_last_name: a,
        ...u
      } = this.overrides;
      this.overrides = u;
    });
    n(this, "addToQueue", (e, i, r) => {
      const o = this.sessionManager.session(), c = C({
        ...this.overrides,
        name: e,
        context_session_id: o.id,
        context_session_started_time: o.startTime,
        ...(r == null ? void 0 : r.parentRecordId) && { caused_by_id: r.parentRecordId },
        ...i && { data: F(i) }
      });
      return this.queue.push(c), c;
    });
    n(this, "flush", () => {
      var r;
      if (!this.queue.length)
        return;
      const e = this.queue.map((o) => ({
        key: o.id,
        value: {
          ...o,
          time_sent: (/* @__PURE__ */ new Date()).getTime()
        }
      }));
      if (this.queue = [], this.options.dryRun)
        return;
      const i = `${((r = this.options) == null ? void 0 : r.BASE_URL) ?? ""}${this.options.ENDPOINT}`;
      try {
        fetch(i, {
          method: "POST",
          keepalive: !0,
          body: JSON.stringify({
            records: e
          }),
          headers: {
            "Content-Type": "application/vnd.kafka.json.v2+json",
            Accept: "application/vnd.kafka.v2+json, application/vnd.kafka+json, application/json"
          }
        });
      } catch {
      }
    });
    this.options = {
      BASE_URL: "",
      ENDPOINT: "/api/events",
      ...e
    }, this.navigationManager = new V(this.handleNavigation), this.sessionManager = new ae(
      () => (
        // execute the session start event in the next tick so that the session id is already set
        Promise.resolve().then(() => this.handleSessionStart())
      ),
      e == null ? void 0 : e.sessionDuration
    ), document.addEventListener("visibilitychange", this.handleVisibilityChange), this.options.verbose && console.log("DataLakeClient: constructor", this.options);
  }
}
export {
  le as DataLakeClient,
  de as SESSION_DURATION,
  R as SESSION_STORAGE_KEY,
  j as getDataLakeSession,
  ue as getDataLakeSessionId,
  C as saturateRecord,
  F as toJSONLikeValues
};
